module.exports = __webpack_public_path__ + "static/media/tailwind-css.17ce3258.svg";